import axios from "../../api/axiosConfig"; // Importing your specific axios config
import {
  PRODUCT_DETAILS_REQUEST,
  PRODUCT_DETAILS_SUCCESS,
  PRODUCT_DETAILS_FAIL,
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_LIST_FAIL,
  PRODUCT_DELETE_REQUEST,
  PRODUCT_DELETE_SUCCESS,
  PRODUCT_DELETE_FAIL,
  PRODUCT_UPDATE_REQUEST,
  PRODUCT_UPDATE_SUCCESS,
  PRODUCT_UPDATE_FAIL
} from "../constants/productConstants";

export const getProductDetails = (id) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_DETAILS_REQUEST });

    const { data } = await axios.get(`/products/${id}`);

    dispatch({
      type: PRODUCT_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_DETAILS_FAIL,
      // Check if error response exists, otherwise send generic message
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Accepts query object and pageNumber
export const listProducts = (query = {}, pageNumber = 1) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_LIST_REQUEST })

    // We pass pageNumber and the rest of the query params
    const config = {
      params: { ...query, pageNumber },
    }

    const { data } = await axios.get('/products/get-products', config)

    dispatch({
      type: PRODUCT_LIST_SUCCESS,
      payload: data, // Assuming backend returns { products, page, pages }
    })
  } catch (error) {
    dispatch({
      type: PRODUCT_LIST_FAIL,
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    })
  }
}

// DELETE ACTION
export const deleteProduct = (id) => async (dispatch) => {
  try {
      dispatch({ type: PRODUCT_DELETE_REQUEST });
      await axios.delete(`/products/${id}`); // Adjust API route as needed
      dispatch({ type: PRODUCT_DELETE_SUCCESS });
  } catch (error) {
      dispatch({
          type: PRODUCT_DELETE_FAIL,
          payload: error.response && error.response.data.message ? error.response.data.message : error.message,
      });
  }
};

// UPDATE ACTION
export const updateProduct = (product) => async (dispatch) => {
  try {
      dispatch({ type: PRODUCT_UPDATE_REQUEST });
      
      const { data } = await axios.put(
          `/products/${product._id}`, // Adjust API route
          product
      );

      dispatch({ type: PRODUCT_UPDATE_SUCCESS, payload: data });
  } catch (error) {
      dispatch({
          type: PRODUCT_UPDATE_FAIL,
          payload: error.response && error.response.data.message ? error.response.data.message : error.message,
      });
  }
};